import { makeStyles } from "@material-ui/core";
import { ErrorBoundary} from "@portal/arq-portal-core"
import React from "react"
import { ChatbotGepetto } from "./ChatbotGepetto";

const useStyles = makeStyles(() => ({
    chatbotButton: {
      position: "fixed",
      bottom: "60px",
      right: "40px",
      borderRadius: "50%",
      width: "60px",
      height: "60px",
      backgroundColor: "rgb(220 0 40 / 60%) !important", 
      color: "white !important",
      fontFamily: "Catalana-sans, Arial, sans-serif !important",
      border: "none !important",
      zIndex: 99,
      minWidth: "0",
      boxShadow: "1px 4px 15px rgb(0 0 0 / 30%)",

    },
    iconChat:{
      fontSize: '37px',
      color: '#ffffffa8 !important',
    }
  }));

//   interface propsChatbot{
//     hide?: boolean;
//     idBot?: string;
//     dominio?: string;
//   }
  

export const WrappedChatbotGepetto = (props: any) => {    
    const classes = useStyles(props);
    return (
        <ErrorBoundary 
            fallback={()=>{
            return <button
                className={classes.chatbotButton}
                type="button"
                disabled
              > 
                 <i className={`icon-chat ${classes.iconChat}`}> </i>
              </button>
            }}
        >
                <ChatbotGepetto {...props} />
        </ErrorBoundary>
    )
}